import { render, staticRenderFns } from "./down-bank-info.vue?vue&type=template&id=ee52f7a0&scoped=true&"
import script from "./down-bank-info.vue?vue&type=script&lang=js&"
export * from "./down-bank-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee52f7a0",
  null
  
)

export default component.exports